const doc = [({"en":({"js":({"admin":({"contact_associates":({"create_card":({"choose_contact":"Choose contact"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;